var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDialerFilled = function SvgDialerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00333e",
    fillRule: "evenodd",
    d: "M15.173 20.289c-1.32-.049-5.061-.566-8.979-4.483-3.917-3.918-4.433-7.658-4.482-8.979-.074-2.013 1.468-3.968 3.25-4.731a1.35 1.35 0 0 1 1.324.145C7.752 3.311 8.764 4.927 9.633 6.2a1.38 1.38 0 0 1-.234 1.82L7.61 9.347a.44.44 0 0 0-.13.565c.405.736 1.126 1.832 1.95 2.657.827.825 1.974 1.593 2.762 2.044a.443.443 0 0 0 .59-.148l1.164-1.772a1.38 1.38 0 0 1 1.885-.304c1.29.893 2.795 1.887 3.897 3.298a1.35 1.35 0 0 1 .173 1.361c-.767 1.79-2.709 3.315-4.728 3.24",
    clipRule: "evenodd"
  })));
};
export default SvgDialerFilled;